<template>
  <div></div>
</template>

<script>
/* This is an intended blank page component */
export default {
  name: 'Close',
};
</script>
